An indicator that the person could start immediately.

Derived from `noticePeriodMeasure`. Values other than 0 weeks will result in `false`.
